import { Phone, Calendar } from "lucide-react";
import { BUSINESS } from "@/config";
import { useBook } from "@/components/CTAButtons";
import { track } from "@/lib/analytics";

export default function StickyMobileCTA() {
  const book = useBook();
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 left-0 z-40 w-full border-t border-border bg-background/85 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <button
          data-testid="sticky-book-button"
          onClick={() => book()}
          className="flex items-center justify-center gap-2 rounded-full bg-primary py-3.5 font-mono text-xs uppercase tracking-[0.14em] text-primary-foreground"
        >
          <Calendar className="h-4 w-4" strokeWidth={1.5} /> Book Now
        </button>
        <a
          data-testid="sticky-call-button"
          href={BUSINESS.phoneHref}
          onClick={() => track("phone_click", { location: "sticky_mobile_bar" })}
          className="flex items-center justify-center gap-2 rounded-full border border-foreground/40 py-3.5 font-mono text-xs uppercase tracking-[0.14em] text-foreground"
        >
          <Phone className="h-4 w-4" strokeWidth={1.5} /> Call / Text
        </a>
      </div>
    </div>
  );
}
